const FooterComponent = () => {


    return (
        <footer>
            <span className="my-footer">
                Contact The Spring Hotel at (123) 456-7890 | All Right Reserved &copy; {new Date().getFullYear()}
            </span>
        </footer>
    );
};

export default FooterComponent;
